import { Permission } from "@forgepoint/shared";
import AccessRestricted from "@/components/AccessRestricted";
import { QuotesController } from "@/modules/quotes/QuotesController";
import { useHasAnyPermission } from "@/store/authStore";

export default function RecordQuotes() {
  const canView = useHasAnyPermission(
    Permission.QUOTES_VIEW_OWN,
    Permission.QUOTES_VIEW_ALL,
  );

  if (!canView) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Records" }, { label: "Quotes", current: true }]}
        message="You do not have access to quotes."
      />
    );
  }

  return <QuotesController />;
}
